import { z } from 'zod'

import { Sale } from './sale'

import { Product } from 'app/types/catalogue/product'
import { KonsoleUser } from 'app/types/users/konsole'

/** Enum type for refund type */
export const TypeRefund = z.enum(['INFORMATION', 'RECREDITATION'])

/** Refund status available. */
export const StatusRefund = z.enum(['APPROVED', 'IN_PROGRESS', 'REFUSED'])

export const ProductRefund = Product.pick({
    id: true,
}).extend({
    amount: z.number().positive(),
})

export const ProductRefundPayload = Product.pick({
    id: true,
    name: true,
    price: true,
}).extend({
    productSaleIds: z.number().positive().array(),
})

export type ProductRefundPayload = z.infer<typeof ProductRefundPayload>

export const RefundPayload = z.object({
    reason: z.string(),
    refunds: z
        .object({
            product: ProductRefundPayload,
            quantity: z.number(),
            amount: z.number(),
        })
        .array(),
})

export type RefundPayload = z.infer<typeof RefundPayload>

/** Refund object sent to the API to make a refund */
export const RefundPayloadBackend = z.object({
    type: TypeRefund,
    reason: z.string().min(1),
    products: ProductRefund.array().min(1),
})

export type RefundPayloadBackend = z.infer<typeof RefundPayloadBackend>

/** Refund object returned by the API after a refund is made */
export const Refund = z.object({
    id: z.number().positive(),
    date: z.string().min(1),
    type: TypeRefund,
    status: StatusRefund,
    amount: z.number().positive(),
    is_employer_contribution_removed: z.boolean(),
    author: KonsoleUser,
    reason: z.string().min(1),
    sale: Sale.shape.id,
    products: Product.array(),
    previous_credit: z.number().positive(),
})

export type Refund = z.infer<typeof Refund>
